import React from 'react';
import Swal from 'sweetalert2';

interface ToastProps {
    title: string;
}

const ErrorToast: React.FC<ToastProps> = ({title}) => {
    Swal.fire({
        customClass: {
            container: 'swal-over-all',
        },
        icon: 'error',
        iconColor: '##ff3333',
        title,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
    });

    return null;
};

export default ErrorToast;
